import { SVGProps } from 'react';
import { AutocompleteClasses } from '@mui/material';

import { SelectSize } from '@lyearn/ui';
import { RendererParams } from '@/components/Form';
import { ListWithTempId } from '@/hooks/useList/useListWithTempId';
import { ExerciseQuestionInput, ResourceResponseTypeEnum } from '@/types/schema';

export enum QuestionItemActions {
  Duplicate = 'DUPLICATE',
  Delete = 'DELETE',
  RemoveImage = 'REMOVE_IMAGE',
}

export interface QuestionsProps {
  error?: string;
  questions: ExerciseQuestionInput[];
  onChange: (questions: ExerciseQuestionInput[]) => void;
  setErrorElement: RendererParams['setErrorElement'];
}

export interface QuestionProps {
  error?: string;
  index: number;
  item: ListWithTempId<ExerciseQuestionInput>;
  onDelete: (index: number) => void;
  responseFormats: ResponseFormatMenuItem[];
  draggingItem: React.MutableRefObject<number | undefined>;
  onDuplicate: (index: number) => void;
  onDrop: (index: number) => void;
  onChangeQuestion: (index: number, question: ListWithTempId<ExerciseQuestionInput>) => void;
}

export interface ResponseFormatMenuItem {
  Icon: (
    _props: SVGProps<SVGSVGElement> & {
      fillColorToken?: string | undefined;
    },
  ) => JSX.Element;
  label: string;
  value: ResourceResponseTypeEnum;
}

export interface SelectFormatProps {
  formats: ResponseFormatMenuItem[];
  selectedValue?: ResourceResponseTypeEnum;
  onChange: (value: ResourceResponseTypeEnum) => void;
  className: string;
  size?: SelectSize;
  placeholder?: string;
  classes?: Partial<AutocompleteClasses>;
  popupIcon?: React.ReactNode;
}
